import React from 'react';
import { withRouter } from 'react-router';
import format from 'date-fns/format';

const getSubscriptionStatus = subscription => {
  const activeText = <span className="badge badge-success">Active</span>;
  const endThisPeriodText = (
    <span className="badge badge-warning">Ends This Period</span>
  );
  const cancelledText = <span className="badge badge-danger">Cancelled</span>;

  if (subscription.status && subscription.status === 'cancelled') {
    return cancelledText;
  }

  if (subscription.cancel_at_period_end) {
    console.log(subscription.cancel_at_period_end);
    return endThisPeriodText;
  }

  return activeText;
};

const renderPlans = items => {
  if (!items.length) {
    return <div>No Plans</div>;
  }

  const totalPrice =
    items &&
    items.reduce((a, b) => {
      const total = a + parseInt(b.plan.amount, 10) * parseInt(b.qty, 10) / 100;
      return total;
    }, 0);

  // console.log('item plan', items[0].plan);
  const interval = items[0].plan.interval;

  return (
    <div>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {items.map((i, idx) => {
          const planName = i.plan.name;
          if (planName === 'Individual') return null;
          const planQty = i.qty;
          const qtyDisplay =
            planQty >= 0 && planName !== 'Individual' ? `(${planQty})` : null;
          return (
            <li key={idx}>
              {planName} {qtyDisplay}
            </li>
          );
        })}
      </ul>
      <div className="text-primary">
        ${totalPrice}/{interval}
      </div>
    </div>
  );
};

const renderInventory = (items, inventory) => {
  if (!items.length) return <div>No Plans</div>;
  // console.log('inv', inventory);
  return (
    <div>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {items.map((i, idx) => {
          const planName = i.plan.name;
          if (planName === 'Individual') return null;
          // const planQty = i.qty;
          const qtyRemaining =
            inventory[i.plan.id] >= 0 && planName !== 'Individual'
              ? `(${inventory[i.plan.id]})`
              : null;
          return (
            <li key={idx}>
              {planName} {qtyRemaining}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

@withRouter
export class SuperAdminSubscriptionItem extends React.Component {
  handleRowClick = subscriptionId => {
    const { organizationId, router } = this.props;
    router.push(
      `/admin/organization/${organizationId}/subscription/${subscriptionId}`,
    );
  };

  render() {
    const {
      subscription,
      disableAdminFeatures,
      hideIdColumn,
      availablePlans,
      cancelSubscription,
      reactivateSubscription,
      isCancellingOrReactivating,
    } = this.props;
    const subscriptionStatus = getSubscriptionStatus(subscription);
    const cancelReactivateBtn = subscription.cancel_at_period_end ? (
      <button
        type="button"
        className="btn btn-info btn-sm"
        onClick={e => {
          e.stopPropagation();
          reactivateSubscription(subscription.id);
        }}
        disabled={isCancellingOrReactivating}
      >
        {isCancellingOrReactivating && (
          <i className="fa fa-cog fa-spinner fa-spin mr-1" />
        )}
        Reactivate Subscription
      </button>
    ) : (
      <button
        type="button"
        className="btn btn-danger btn-sm"
        onClick={e => {
          e.stopPropagation();
          cancelSubscription(subscription.id);
        }}
        disabled={isCancellingOrReactivating}
      >
        {isCancellingOrReactivating && (
          <i className="fa fa-cog fa-spinner fa-spin fa-spin mr-1" />
        )}
        Cancel Subscription
      </button>
    );

    return (
      <tr
        onClick={() => {
          if (!disableAdminFeatures) {
            this.handleRowClick(subscription.id);
          }
        }}
        style={{ cursor: !disableAdminFeatures ? 'pointer' : 'auto' }}
      >
        {hideIdColumn ? null : <th scope="row">{subscription.id}</th>}
        <td className="subscription-status">{subscriptionStatus}</td>
        <td>{renderPlans(subscription.items)}</td>
        <td>{subscription.created_at}</td>
        <td>{renderInventory(subscription.items, availablePlans)}</td>
        <td>
          {subscription.status !== 'cancelled' ? cancelReactivateBtn : null}
        </td>
      </tr>
    );
  }
}

export class OrgAdminSubscriptionItem extends React.Component {
  render() {
    const { subscription, availablePlans } = this.props;
    const subscriptionStatus = getSubscriptionStatus(subscription);
    return (
      <tr>
        <td className="subscription-status">{subscriptionStatus}</td>
        <td>{renderPlans(subscription.items)}</td>
        <td>{subscription.created_at}</td>
        <td>{renderInventory(subscription.items, availablePlans)}</td>
      </tr>
    );
  }
}

export default class SubscriptionItem extends React.Component {
  render() {
    const Component = this.props.disableAdminFeatures
      ? OrgAdminSubscriptionItem
      : SuperAdminSubscriptionItem;
    return <Component {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/SubscriptionItem.js